import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CommonNotificationObject } from '../types';
import { INotificationAttrs } from '../../AppComponents/Notifications/types';

interface IAddOrgNotificationsReducerState extends Record<string, any> {
  notificationAttrs: INotificationAttrs;
  notification: CommonNotificationObject;
}

export const initialState: IAddOrgNotificationsReducerState = {
  notification: {},
  notificationAttrs: {} as INotificationAttrs,
};

const addOrgNotificationsSlice = createSlice({
  name: 'addOrgNotifications',
  initialState,
  reducers: {
    changeAddOrgNotification(
      state,
      action: PayloadAction<CommonNotificationObject>,
    ) {
      state.notification = action.payload;

      if (Object.keys(state.notificationAttrs).length <= 0) {
        state.notificationAttrs = {
          mainLoad: 0,
          failed: false,
          fullyComplete: false,
        };
      }
    },
    changeAddOrgNotificationAttrs(
      state,
      action: PayloadAction<Record<keyof INotificationAttrs, any>>,
    ) {
      state.notificationAttrs = {
        ...state.notificationAttrs,
        ...action.payload,
      };
    },
    clearAddOrgNotifications() {
      return initialState;
    },
  },
});

export const {
  changeAddOrgNotification,
  clearAddOrgNotifications,
  changeAddOrgNotificationAttrs,
} = addOrgNotificationsSlice.actions;

export default addOrgNotificationsSlice.reducer;
